if (!window.aracwebshop) window.aracwebshop = {}
if (!frappe.boot) frappe.boot = {}

// Product listing images are deliberately smaller than product-detail images.
// The modified timestamp also makes a backend image replacement visible even
// when the new file reuses the previous URL and Safari has cached it.
window.aracwebshopImages = window.aracwebshopImages || (() => {
	function add_version(url, modified) {
		url = url == null ? "" : String(url);
		// Do not alter third-party or signed image URLs. Local Frappe files are the
		// paths whose cache lifetime we control and whose backend replacements need
		// an explicit version.
		if (!url || !modified || /^(?:data|blob|https?):/i.test(url)) return url;

		const version = encodeURIComponent(String(modified));
		const hash_index = url.indexOf("#");
		const hash = hash_index >= 0 ? url.slice(hash_index) : "";
		let base = hash_index >= 0 ? url.slice(0, hash_index) : url;

		if (/([?&])v=[^&#]*/.test(base)) {
			base = base.replace(/([?&])v=[^&#]*/, `$1v=${version}`);
		} else {
			base += `${base.includes("?") ? "&" : "?"}v=${version}`;
		}

		return base + hash;
	}

	function get_listing_image(item) {
		item = item || {};
		return add_version(item.thumbnail || item.website_image || "", item.modified);
	}

	return {add_version, get_listing_image};
})();
